export default {
    showMessage: (data, toast) => {
        if (!Object.keys(data).length || !data.code) {
            return;
        }

        let message = {};
        if ((typeof data.message) !== 'string') {
            message.code = data.code;
            let obj = data.message;
            Object.keys(obj).forEach(function (key) {
                message.message = obj[key];
            });
        } else {
            message = data;
        }

        switch (message.code) {
            case 'info':
                toast.info(message.message);
                break;
            case 'success':
                toast.success(message.message);
                break;
            case 'warning':
            case 'error':
                toast.error(message.message);
                break;
            default:
                toast.show(message.message);
                break;
        }
    },
    nl2br: (str) => {
        if(!str) {
        return str;
    }

    str = str.replace(/\r\n/g, "<br />");
    str = str.replace(/(\n|\r)/g, "<br />");
    return str;
    }
}
